const defaultBaseUrl = 'https://kwhomes.co.za';

export function kwhomesBaseUrl(configured?: string): string {
  return (configured?.trim() || defaultBaseUrl).replace(/\/+$/, '');
}

export function agentWebsiteUrl(kwuid: string | null | undefined, configuredBaseUrl?: string): string | null {
  if (!kwuid || !/^[0-9]{3,12}$/.test(kwuid)) return null;
  return `${kwhomesBaseUrl(configuredBaseUrl)}/${encodeURIComponent(kwuid)}`;
}

export function agentVCardUrl(kwuid: string | null | undefined, configuredBaseUrl?: string): string | null {
  if (!kwuid || !/^[0-9]{3,12}$/.test(kwuid)) return null;
  return `${kwhomesBaseUrl(configuredBaseUrl)}/vcard/${encodeURIComponent(kwuid)}`;
}
